import React from 'react'
import PropTypes from 'prop-types'

import { useFormContext } from 'react-hook-form'

import { get } from 'utils/lodash'
import { HHFormTextField } from 'components/form-fields/v5'
import { useGetRentalFeesQuery } from 'api/pricing/rentalFeesCrud'
import { getRentalFees } from 'data/pricing/rentalFeeSelectors'

import SelectItem from 'components/form-fields/v5/SelectItem'
import RenderNoneOption from './RenderNoneOption'
import RentalFeeListItem from './RentalFeeListItem'

const RentalFeeFormField = ({ name, value, hideArchived = false, disabled = false, onChange }) => {
  const { control } = useFormContext()
  const { data: rentalFeesData } = useGetRentalFeesQuery()
  const rentalFees = getRentalFees({ rentalFees: get(rentalFeesData, 'rentalFees', []), hideArchived })

  const handleChange = newRentalFeeId => {
    if (newRentalFeeId) {
      const selectedRentalFee = rentalFees.find(fee => fee.id === newRentalFeeId)
      onChange(selectedRentalFee)
    }
  }

  return (
    <HHFormTextField
      fullWidth
      select
      control={control}
      name={name}
      value={[value]}
      deprecatedLabel={false}
      disabled={disabled}
      onChange={handleChange}
      variant="standard"
      size="small"
      sx={{
        width: '100%',
        mb: 2,
        px: 4,
      }}
    >
      <SelectItem value="">
        <RenderNoneOption />
      </SelectItem>
      {rentalFees.map(fee => (
        <SelectItem value={fee.id}>
          <RentalFeeListItem rentalFee={fee} />
        </SelectItem>
      ))}
    </HHFormTextField>
  )
}

RentalFeeFormField.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  hideArchived: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
}

export default RentalFeeFormField
